"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M5.22266 18H1.66016L1.68359 16.1602H5.22266C6.44141 16.1602 7.45703 15.9062 8.26953 15.3984C9.08203 14.8828 9.69141 14.1641 10.0977 13.2422C10.5117 12.3125 10.7188 11.2266 10.7188 9.98438V8.94141C10.7188 7.96484 10.6016 7.09766 10.3672 6.33984C10.1328 5.57422 9.78906 4.92969 9.33594 4.40625C8.88281 3.875 8.32812 3.47266 7.67188 3.19922C7.02344 2.92578 6.27734 2.78906 5.43359 2.78906H1.58984V0.9375H5.43359C6.55078 0.9375 7.57031 1.125 8.49219 1.5C9.41406 1.86719 10.207 2.40234 10.8711 3.10547C11.543 3.80078 12.0586 4.64453 12.418 5.63672C12.7773 6.62109 12.957 7.73047 12.957 8.96484V9.98438C12.957 11.2188 12.7773 12.332 12.418 13.3242C12.0586 14.3086 11.5391 15.1484 10.8594 15.8438C10.1875 16.5391 9.375 17.0742 8.42188 17.4492C7.47656 17.8164 6.41016 18 5.22266 18ZM2.86719 0.9375V18H0.605469V0.9375H2.86719Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;